import { FC } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Color, Path, Svg } from "react-native-svg";

const PdArrowRight: FC<{ style?: StyleProp<ViewStyle>; color?: Color }> = ({ style, color }) => (
  <Svg style={style} viewBox="0 0 25 12" fill="none">
    <Path
      d="M19.1176 0L18.0041 1.11363L21.9853 5.09494H0V6.66986H21.9853L18.0041 10.6618L19.1176 11.7754L25 5.88235L19.1176 0Z"
      fill={color || "#000"}
    />
  </Svg>
);

export default PdArrowRight;
